import config from 'constants/config'
import {
  OFFER_TYPE_HOTEL,
  OFFER_TYPE_BUNDLE_AND_SAVE,
  OFFER_TYPE_TOUR,
  OFFER_TYPE_ALWAYS_ON,
  OFFER_TYPE_BED_BANK,
  OFFER_TYPE_TOUR_V2,
} from 'constants/offer'
import { isEnabledForFeature } from 'lib/featureFlagUtils'

function taoOnFrontPage(regionCode: string) {
  return config.TAO_ON_FRONT_PAGE && !isEnabledForFeature(config.TAO_ON_FRONT_PAGE_DISABLED_REGIONS, regionCode)
}

export const PAGE_SIZE = 4
export const MAX_OFFERS_PER_REQUEST = 25
export const FLASH_OFFERS_TYPES: Array<App.LEContractedOfferType> = [OFFER_TYPE_HOTEL, OFFER_TYPE_TOUR]
export const FLASH_AND_TAO_OFFERS_TYPES: Array<App.LEContractedOfferType> = [OFFER_TYPE_HOTEL, OFFER_TYPE_TOUR, OFFER_TYPE_ALWAYS_ON]
export const FLASH_HOTELS_AND_TAO_OFFERS_TYPES: Array<App.LEContractedOfferType> = [OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON]

// These need to be functions so that they're evaluated after the config is set.
// They can be turned back into normal constants once we launch TAO on front page for all regions.
export const FRONT_PAGE_OFFERS_TYPES =
  (regionCode: string) => [...(taoOnFrontPage(regionCode) ? FLASH_AND_TAO_OFFERS_TYPES.concat(config.ENABLE_BUNDLE_AND_SAVE ? [OFFER_TYPE_BUNDLE_AND_SAVE] : []) : FLASH_OFFERS_TYPES.concat(config.ENABLE_BUNDLE_AND_SAVE ? [OFFER_TYPE_BUNDLE_AND_SAVE] : [])), OFFER_TYPE_TOUR_V2]

export const FRONT_PAGE_MAP_VIEW_OFFERS_TYPES =
  (regionCode: string) => taoOnFrontPage(regionCode) ? FLASH_AND_TAO_OFFERS_TYPES.concat(config.ENABLE_BUNDLE_AND_SAVE ? [OFFER_TYPE_BUNDLE_AND_SAVE] : []) : FLASH_OFFERS_TYPES.concat(config.ENABLE_BUNDLE_AND_SAVE ? [OFFER_TYPE_BUNDLE_AND_SAVE] : [])

const FLASH_HOTEL_AND_TAO: Array<App.LEContractedOfferType> = config.ENABLE_BUNDLE_AND_SAVE ? [OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BUNDLE_AND_SAVE] : [OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON]
const FLASH_HOTEL: Array<App.LEContractedOfferType> = config.ENABLE_BUNDLE_AND_SAVE ? [OFFER_TYPE_HOTEL, OFFER_TYPE_BUNDLE_AND_SAVE] : [OFFER_TYPE_HOTEL]
export const HOTEL_PAGE_OFFER_TYPES: (regionCode: string) => Array<App.LEContractedOfferType> =
  (regionCode: string) => taoOnFrontPage(regionCode) ? FLASH_HOTEL_AND_TAO : FLASH_HOTEL

export const BEDBANK_ONLY: Array<App.OfferType> = [OFFER_TYPE_BED_BANK]
